import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { saveAirbnbInvoice } from 'modules/accommodations/features/reservations/api';

export const useMutationSaveAirbnbInvoice = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { successToast, errorToast } = useCustomToast();

  return useMutation(saveAirbnbInvoice, {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.UNITS_RESERVATIONS_PAYMENTS, {
        refetchInactive: true,
      });
      queryClient.invalidateQueries(QUERY_KEYS.UNITS_RESERVATION_TYPE, {
        refetchInactive: true,
      });
      successToast(t('Airbnb invoice successfully saved'));
    },
    onError: (error: AxiosError) => {
      const errorMessage = error.response?.data as { ErrorDescription: string };
      errorToast(errorMessage?.ErrorDescription);
    },
  });
};
